import { render } from "./cotizacion.vue?vue&type=template&id=58e8eafa"
import script from "./cotizacion.vue?vue&type=script&lang=js"
export * from "./cotizacion.vue?vue&type=script&lang=js"

import "./cotizacion.vue?vue&type=style&index=0&id=58e8eafa&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__